import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';

const { dispatch } = store;

let isUpdatePage = false;
let delayInAddRequest = 10;
let idAddRequest = null;
let requests = [];
let curPathname = typeof window !== 'undefined' ? window.location.pathname : '';
let unsubscribe = null;

function bindLocationListener() {
    if (typeof window === 'undefined' || !window.history) return;

    const onChange = () => {
        const next = window.location.pathname || '';
        if (curPathname !== next) {
            PaceProgressActions.startUpdatePage();
            curPathname = next;
        }
    };

    const origPush = window.history.pushState;
    const origReplace = window.history.replaceState;

    if (!window.__pace_history_patched__) {
        window.history.pushState = function (...args) {
            const r = origPush.apply(this, args);
            window.dispatchEvent(new Event('locationchange'));
            return r;
        };
        window.history.replaceState = function (...args) {
            const r = origReplace.apply(this, args);
            window.dispatchEvent(new Event('locationchange'));
            return r;
        };
        window.__pace_history_patched__ = true;
    }

    window.addEventListener('popstate', onChange);
    window.addEventListener('locationchange', onChange);

    unsubscribe = () => {
        window.removeEventListener('popstate', onChange);
        window.removeEventListener('locationchange', onChange);
    };
}

const PaceProgressActions = {
    init() {
        curPathname = typeof window !== 'undefined' ? window.location.pathname : '';
        bindLocationListener();
    },

    destroy() {
        if (unsubscribe) unsubscribe();
        unsubscribe = null;
    },

    onLocationChange(nextPathname) {
        if (curPathname !== nextPathname) {
            this.startUpdatePage();
            curPathname = nextPathname;
        }
    },

    startUpdatePage() {
        isUpdatePage = true;
        this.active();
    },

    endUpdatePage() {
        isUpdatePage = false;
        Promise.all(requests).then(() => {
            requests = [];
            this.clear();
        }).catch(() => {
            requests = [];
            this.clear();
        });
    },

    addRequest(promise) {
        if (!isUpdatePage) return;

        requests.push(promise);
        this.totalIncrement();

        clearTimeout(idAddRequest);
        idAddRequest = setTimeout(() => this.endUpdatePage(), delayInAddRequest);

        promise
            .then(() => this.uploadedIncrement())
            .catch(() => this.uploadedIncrement());
    },

    active() {
        dispatch({ type: AppConstants.PACE_PROGRESS_ACTIVE });
    },

    totalIncrement() {
        dispatch({ type: AppConstants.PACE_PROGRESS_TOTAL_INCREMENT });
    },

    uploadedIncrement() {
        dispatch({ type: AppConstants.PACE_PROGRESS_UPLOADED_INCREMENT });
    },

    clear() {
        dispatch({ type: AppConstants.PACE_PROGRESS_CLEAR });
    },
};

export default PaceProgressActions;
